// removed by extract-text-webpack-plugin
module.exports = {"root":"_PN5d_","title":"_3D45T","purposePanel":"_2HB--","panel":"_1oIZG"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Tutors/components/ReasonPanel/Reason.scss
// module id = 1597
// module chunks = 8